export const SHOW_TOAST = 'SHOW_TOAST';
export const HIDE_TOAST = 'HIDE_TOAST';

export const showToast = (message, type = 'success', loading = false) => ({
  type: SHOW_TOAST,
  payload: { message, type, loading },
});

export const hideToast = () => ({
  type: HIDE_TOAST,
});